import React, { Component } from "react";
import "../../assets/web/assets/mobirise-icons2/mobirise2.css";
import "../../assets/web/assets/mobirise-icons/mobirise-icons.css";
import "../../assets/tether/tether.min.css";
import "../../assets/bootstrap/css/bootstrap.min.css";
import "../../assets/bootstrap/css/bootstrap-grid.min.css";
import "../../assets/bootstrap/css/bootstrap-reboot.min.css";
import "../../assets/dropdown/css/style.css";
import "../../assets/socicon/css/styles.css";
import "../../assets/theme/css/style.css";
import "../../assets/mobirise/css/mbr-additional.css";
import { Navbar, Nav } from "react-bootstrap";
import logo from "../../assets/images/logowhiterecmin.png";
class BusinessTermsPage extends Component {
  state = {};

  render() {
    return (
      <div>
        <section className="menu menu2 cid-smIpILaFmX" once="menu" id="menu2-0">
          <Navbar
            collapseOnSelect
            expand="lg"
            className="navbar navbar-dropdown navbar-fixed-top navbar-expand-lg"
            style={{ backgroundColor: "rgba(98, 98, 98, 0.5)" }}
          >
            <div className="container-fluid">
              <Navbar.Brand className="navbar-brand" href="#home">
                <span className="navbar-logo">
                  <a href="/">
                    <img
                      src={logo}
                      alt="MassTaxi"
                      title=""
                      style={{ height: "2rem" }}
                    />
                  </a>
                </span>
              </Navbar.Brand>
              {/* <Navbar.Toggle aria-controls="responsive-navbar-nav" /> */}
              <Navbar.Toggle
                className="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarNavAltMarkup"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <div className="hamburger">
                  <span />
                  <span />
                  <span />
                  <span />
                </div>
              </Navbar.Toggle>
              <Navbar.Collapse
                className="collapse navbar-collapse"
                id="navbarSupportedContent"
              >
                <Nav className="navbar-nav nav-dropdown nav-right">
                  <Nav.Link
                    className="nav-link link text-white text-primary display-4"
                    href="/"
                  >
                    Home
                  </Nav.Link>
                  <a
                    className="btn btn-primary display-4"
                    href="/business_login"
                  >
                    Login
                  </a>
                </Nav>
              </Navbar.Collapse>
            </div>
          </Navbar>
        </section>

        <section className="video5 cid-sDASpiFqID" id="video5-22">
          <div className="container">
            <div className="title-wrapper mb-5">
              <h4 className="mbr-section-title mbr-fonts-style mb-0 display-2">
                <strong>Terms and Conditions</strong>
              </h4>
            </div>
            <div className="row align-items-center">
              <div className="col-12 col-lg">
                <div className="text-wrapper">
                  <p className="mbr-text mbr-fonts-style display-7">
                    MassTaxi is an audio-based advertisement platform provided
                    by DAST ICT Solutions PLC.
                    <br />
                    DAST ICT Solutions PLC has full control of MassTaxi and its
                    services.
                    <br />
                    <br />
                    Whenever you deposit money in our system, you agree to give
                    the final say on the deposited credit to DAST ICT Solutions
                    PLC.
                    <br />
                    <br />
                    DAST ICT Solutions PLC has full control over which
                    advertisements can be disseminated. DAST ICT Solutions PLC
                    has the full right to approve, disapprove, and takedown any
                    advertisement content if it contains:
                    <br />
                    • Defamatory commentary and hate speech about religion,
                    gender, race, and other targeted groups,
                    <br />
                    • Overly sexual material,
                    <br />
                    • Portrayals of extreme violence or content that encourages
                    violence,
                    <br />
                    • Bullying and harassment, and
                    <br />
                    • Illegal activities such as drug use.
                    <br />• And other content which can be viewed as negative by
                    DAST ICT Solutions PLC.
                    <br />
                    <br />
                    Any fee you pay for MassTaxi's services is not refundable
                    unless DAST ICT Solutions PLC decides it is absolutely
                    necessary. DAST ICT Solutions PLC has full authority in any
                    transaction regarding refunds.
                    <br />
                    <br />
                    The termination or suspension of an advertisement might take
                    time. DAST ICT Solutions PLC is not liable for any loses
                    that might have happened in that period of time.
                    <br />
                    <br />
                    Even though MassTaxi is powered by data-driven algorithms,
                    it might not provide correct and accurate predictions and
                    statistics. DAST ICT Solutions PLC is not liable for any
                    miscalculations and predictions. DAST ICT Solutions PLC will
                    not be liable for any loss that clients may face because of
                    the failure of the system.
                  </p>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="footer3 cid-smIvGalAcO"
          once="footers"
          id="footer3-1u"
        >
          <div className="container">
            <div className="media-container-row align-center mbr-white">
              <div className="row row-links">
                <ul className="foot-menu">
                  <li className="foot-menu-item mbr-fonts-style display-7">
                    <a href="/" className="text-primary">
                      Home
                    </a>
                  </li>
                  <li className="foot-menu-item mbr-fonts-style display-7">
                    <a href="/contacts" className="text-primary">
                      Contact Us
                    </a>
                  </li>
                  <li className="foot-menu-item mbr-fonts-style display-7">
                    <a href="/driver" className="text-primary">
                      Driver
                    </a>
                  </li>
                  <li className="foot-menu-item mbr-fonts-style display-7">
                    <a href="/business_login" className="text-primary">
                      Login
                    </a>
                  </li>
                </ul>
              </div>
              <div className="row social-row">
                <div className="social-list align-right pb-2">
                  <div className="soc-item">
                    <a
                      href="https://www.facebook.com/masstaxiads"
                      rel="noreferrer"
                      target="_blank"
                    >
                      <span className="socicon-facebook socicon mbr-iconfont mbr-iconfont-social" />
                    </a>
                  </div>
                  <div className="soc-item">
                    <a
                      href="https://www.youtube.com/channel/UCsBTZqPsr-ceq197Fz1gYcw"
                      rel="noreferrer"
                      target="_blank"
                    >
                      <span className="socicon-youtube socicon mbr-iconfont mbr-iconfont-social" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="row row-copirayt">
                <p className="mbr-text mb-0 mbr-fonts-style mbr-white align-center display-7">
                  © MassTaxi 2021. Service Provided by DAST ICT Solutions PLC.
                  All Rights Reserved.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default BusinessTermsPage;
